import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-welcome-layout',
  imports: [RouterOutlet],
  templateUrl: './welcome-layout.component.html',
  styleUrl: './welcome-layout.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WelcomeLayoutComponent {}
